/* KAGE draft #11 : fondu au scroll (une seule fois) */
(function(){
  var sel='.shopify-section > *:not(.header-wrapper), .card-wrapper, .product__info-container, .spec-cartel';
  var els=[].slice.call(document.querySelectorAll(sel)).filter(function(e){return !e.closest('header,.header-wrapper,#shopify-section-header,.shopify-section-group-header-group');});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){ var r=e.getBoundingClientRect(); if(r.top<window.innerHeight){return;} e.classList.add('tn-reveal'); io.observe(e); });
  }
})();
